import * as Yup from 'yup';

// max was made big so that it is essentially irrelevant unless you give stringValidation a max
const stringValidation = ({
  min = 0,
  max = 9999999999,
  pattern = '',
  patternMsg = 'Is not in correct format',
  required = true,
} = {}) =>
  Yup.string()
    .trim()
    .min(min, `Must be at least ${min} characters`)
    .matches(new RegExp(`${pattern}`), patternMsg)
    .max(max)
    .when([], {
      is: () => required,
      then: Yup.string().required('Required'),
      otherwise: Yup.string(),
    });

const companyNameValidation = ({ min = 4 } = {}) =>
  stringValidation({
    min,
  });

const usernameValidation = ({
  min = 4,
  pattern = '^(?=.*[A-Za-z])[A-Za-z0-9]*$',
  patternMsg = 'Special characters not allowed. Valid characters are A-Z a-z 0-9',
} = {}) =>
  stringValidation({
    min,
    pattern,
    patternMsg,
  });

const emailValidation = ({ max = 40 } = {}) =>
  Yup.string().email('Must be a valid email').max(max).required('Required');

const phoneValidation = ({
  pattern = '^[0-9]{3}-[0-9]{3}-[0-9]{4}$',
  patternMsg = '10 numbers, ex. "888-432-5555"',
} = {}) =>
  stringValidation({
    pattern,
    patternMsg,
  });

const cityValidation = ({ pattern = '^[a-zA-Z ]*$', patternMsg = 'Letters only', required } = {}) =>
  stringValidation({
    pattern,
    patternMsg,
    required,
  });

const zipValidation = ({
  min = 5,
  pattern = '^[0-9]*$',
  patternMsg = 'Numbers only',
  required,
} = {}) =>
  stringValidation({
    min,
    pattern,
    patternMsg,
    required,
  });

const passwordValidation = ({
  min = 8,
  pattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$',
  patternMsg = 'At least one uppercase, one lowercase, and one digit',
} = {}) =>
  stringValidation({
    min,
    pattern,
    patternMsg,
  });

const confirmPasswordValidation = () => {
  return Yup.string().test('Passwords match', 'Passwords must match', function (value) {
    return this.parent.password === value;
  });
};

const fileValidation = () => Yup.mixed().required();

const arrayValidation = (yupObject, arrayLength = 0) => {
  if (arrayLength == 0) {
    return Yup.array().of(Yup.object().shape(yupObject));
  } else return Yup.array().of(Yup.object().shape(yupObject)).length(arrayLength);
};

const mustBeNumber = () => Yup.number().typeError('Numbers only').required('Required');

export {
  stringValidation,
  companyNameValidation,
  usernameValidation,
  emailValidation,
  phoneValidation,
  cityValidation,
  zipValidation,
  passwordValidation,
  confirmPasswordValidation,
  fileValidation,
  arrayValidation,
  mustBeNumber,
};
